import type { ChatQuizInterviewSectionSettings } from "@repo/app-types/entities/interviewSection/settings";
import type { FC } from "react";
import { BaseInterviewSectionDefinitionCard } from "../card.js";
import { ChatQuizInterviewSectionDefinitionSettings } from "./settings.js";

export interface ChatQuizInterviewSectionDefinitionCardProps {
  interviewSectionDefinitionId: string;
  settings: ChatQuizInterviewSectionSettings;
  onChange: (
    interviewSectionDefinitionId: string,
    newSettings: ChatQuizInterviewSectionSettings,
  ) => void;
  onDelete: (interviewSectionDefinitionId: string) => void;
}

export const ChatQuizInterviewSectionDefinitionCard: FC<
  ChatQuizInterviewSectionDefinitionCardProps
> = (props) => {
  return (
    <BaseInterviewSectionDefinitionCard
      interviewSectionDefinitionId={props.interviewSectionDefinitionId}
      title={props.settings.topic || "Chat quiz"}
      subtitle="Test and train employee knowledge in a short AI-based chat quiz."
      onDelete={props.onDelete}
    >
      <ChatQuizInterviewSectionDefinitionSettings
        interviewSectionDefinitionId={props.interviewSectionDefinitionId}
        settings={props.settings}
        onChange={props.onChange}
      />
    </BaseInterviewSectionDefinitionCard>
  );
};
